import React from "react";

export default function Promos() {
  return (
    <>
      <div className="overflow-hidden bg-black py-10 sm:py-12">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-6 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-8 lg:pt-4">
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
                <div className="relative pt-0 sm:pt-10">
                  <div className="grid grid-flow-row auto-rows-max">
                    <div className="flow-root">
                      <ul className="">
                        <li className="py-5 sm:py-8">
                          <div className="flex items-center mb-4">
                            <div className="flex-shrink-0 mr-4">
                              <img
                                className="h-16"
                                src="/VerifyNumbers-icon.svg"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 min-w-0 ms-4">
                              <p className="text-white uppercase text-xl text-left font-black italic sm:text-3xl">
                                Verify Numbers
                              </p>
                              <p className="text-white text-base sm:text-lg text-left font-extralight pt-2">
                                Each combine is officiated to give athletes
                                accurate and precise numbers.
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="py-5 sm:py-8">
                          <div className="flex items-center mb-4">
                            <div className="flex-shrink-0 mr-4">
                              <img
                                className="h-16"
                                src="/MaximizeExposure_icon.svg"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 min-w-0 ms-4">
                              <p className="text-white uppercase text-xl text-left font-black italic sm:text-3xl">
                                Maximize Exposure
                              </p>
                              <p className="text-white text-base sm:text-lg text-left font-extralight pt-2">
                                Expand visibility to amplify opportunities and
                                reach potential recruiters.
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="py-5 sm:py-8">
                          <div className="flex items-center mb-4">
                            <div className="flex-shrink-0 mr-4">
                              <img
                                className="h-16"
                                src="/BreakLimits_icon.svg"
                                alt=""
                              />
                            </div>
                            <div className="flex-1 min-w-0 ms-4">
                              <p className="text-white uppercase text-xl text-left font-black italic sm:text-3xl">
                                Break Limits
                              </p>
                              <p className="text-white text-base sm:text-lg text-left font-extralight pt-2">
                                Prove your performance to coaches in areas that
                                you control.
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </dl>
            </div>
            <img
              alt="Product screenshot"
              src="/athletes_bg.png"
              width={2432}
              height={1442}
              className="w-[28rem] max-w-none sm:w-[54rem] md:-ml-4 lg:-ml-0"
            />
          </div>
        </div>
      </div>
    </>
  );
}
